import React, { useCallback } from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import {
  ArticleRating as UIFoundationsArticleRating,
  ArticleRatingValue
} from '@dcxwam/dcx-wam-ui-foundations'
import { useExtractEditableProps } from '../../../../utils/aem/editor/extractEditableProps'
import withComponentRefresh from '../../../../utils/aem/editor/withComponentRefresh'
import ArticleRatingEditConfig from './ArticleRatingEditConfig'
import { ArticleRatingModelProps } from './types'
import { executeSubmitRating } from '../common/FaqsUtils'

const ArticleRating = (props: { model: ArticleRatingModelProps }) => {
  const { model } = props
  const {
    title,
    thumbsUpAriaLabel,
    thumbsDownAriaLabel,
    successMessage,
    feedbackMessage,
    articleId,
    ...rest
  } = model

  const editableProps = useExtractEditableProps(props, rest)

  const handleRate = useCallback(
    async (value: ArticleRatingValue): Promise<void> => {
      // If no articleId configured, skip API call (component works as display-only)
      if (!articleId) {
        return
      }
      // Call async function without awaiting - fire and forget
      await executeSubmitRating(articleId, value)
    },
    [articleId]
  )
  // Extract config object for cleaner JSX and better readability
  const articleRatingConfig = {
    title,
    positiveFeedbackMessage: successMessage,
    negativeFeedbackMessage: feedbackMessage,
    positiveButtonProps: { 'aria-label': thumbsUpAriaLabel },
    negativeButtonProps: { 'aria-label': thumbsDownAriaLabel },
    onRate: handleRate
  }
  return (
    <EditableComponent {...editableProps}>
      {ArticleRatingEditConfig.isEmpty(props) ? (
        ArticleRatingEditConfig.emptyLabel
      ) : (
        <UIFoundationsArticleRating {...articleRatingConfig} />
      )}
    </EditableComponent>
  )
}

export default withComponentRefresh(ArticleRating)
